import io from 'socket.io-client';
const socket = io('https://api.iotgh-bisipujon.online');
// const socket = io('http://127.0.0.1:4000');
export default socket;